import {
    CORE_CREATE_TITLE_SUCCESS,
    CORE_CREATE_TITLE_REQUEST,

    CORE_EDIT_TITLE_SUCCESS,
    CORE_EDIT_TITLE_REQUEST,

    CORE_LOAD_ALL_TITLE_SUCCESS,
    CORE_LOAD_ALL_TITLE_REQUEST,

    CORE_LOAD_TITLE_SUCCESS,
    CORE_LOAD_TITLE_REQUEST,

    CORE_DELETE_TITLE_SUCCESS,
    CORE_DELETE_TITLE_REQUEST,
} from '../../types'

const initialState = []
export default {
    title: (state = initialState, action) => {
        switch (action.type) {
            case CORE_CREATE_TITLE_REQUEST:
            case CORE_LOAD_TITLE_REQUEST:
            case CORE_EDIT_TITLE_REQUEST:
            case CORE_DELETE_TITLE_REQUEST:
                return initialState

            case CORE_CREATE_TITLE_SUCCESS:
            case CORE_LOAD_TITLE_SUCCESS:
            case CORE_EDIT_TITLE_SUCCESS:
            case CORE_DELETE_TITLE_SUCCESS:
                if (action.payload) {
                    return action.payload
                }
                else return {}

            default:
                return state
        }
    },
    titleList:(state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ALL_TITLE_REQUEST:
                return initialState

            case CORE_LOAD_ALL_TITLE_SUCCESS:
                if (action.payload) {
                    return action.payload
                }
                else return [{}]

            default:
                return state
        }
    },

}


// WEBPACK FOOTER //
// ./src/features/title/reducer.js